'use client';

import { useTranslations } from '@dealerportal/i18n/client';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

// biome-ignore lint/suspicious/noShadowRestrictedNames: NextJS requires the name be Error
export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const t = useTranslations('common');

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <p>{t('errorOccurred')}</p>;
}
